import { z } from "zod";

export const QuizSettingsSchema = z.object({
    isActive: z.boolean(),
    time: z.number().min(0),
    veryHardCount: z.number().min(0),
    hardCount: z.number().min(0),
    mediumCount: z.number().min(0),
    easyCount: z.number().min(0),
    type: z.enum(['1', '2']).optional().nullable()
})

export const QuestionBankServerResponseSchema = z.object({
    veryHardCount: z.number(),
    hardCount: z.number(),
    mediumCount: z.number(),
    easyCount: z.number(),
})

export const ExamSchema = z.object({
    id: z.number(),
    title: z.string(),
    dateLiteral: z.string(),
    date: z.string(),
    settings: z.unknown(),
    students: z.string(),
    isActive: z.boolean(),
    resultLink: z.string().optional().nullable(),
    started: z.boolean().optional().nullable(),
    finished: z.boolean().optional().nullable(),
    expired: z.boolean().optional().nullable()
})

export const quizDefaultValues = {
    isActive: undefined,
    time: 15,
    veryHardCount: 1,
    hardCount: 4,
    mediumCount: 3,
    easyCount: 2,
    type: '1' as '1' | "2"
}

export const ExamStateSchema = z.object({
    title: z.string().optional().nullable(),
    exam_id: z.number().optional().nullable(),
    status: z.enum(['none', 'active', 'unfinished'])
})

export const ExamServerResponseSchema = z.array(ExamSchema);

export const PaginatedServerResponseSchema = z.object({
    data: ExamServerResponseSchema,
    meta: z.object({
        last_page: z.number(),
        current_page: z.number()
    })
})

export type ExamType = z.infer<typeof ExamSchema>;
export type ExamServerResponseType = z.infer<typeof ExamServerResponseSchema>;
export type PaginatedServerResponseType = z.infer<typeof PaginatedServerResponseSchema>;
export type ExamStateType = z.infer<typeof ExamStateSchema>;